import { toast } from 'components/ui/use-toast';

export function validateDocumentFormat(event: React.ChangeEvent<HTMLInputElement>) {
  const input = event.target;
  if (!input.files) return;
  const allowedExtensions = [
    '.pdf',
    '.doc', '.docx', '.dot', '.dotx', '.odt', '.rtf',
    '.png', '.webp', '.jpg', '.jpeg', '.bmp', '.gif', '.svg', '.tif', '.tiff', '.heic', '.avif'
  ];
  const validFiles = Array.from(input.files).filter((file) => {
    const ext = '.' + file.name.split('.').pop()?.toLowerCase();
    return allowedExtensions.includes(ext);
  });
  if (validFiles.length === 0) {
    toast({
      variant: 'alert',
      description: 'Por favor, selecione apenas arquivos PDF, Word ou imagens suportadas (PNG, JPG, JPEG, WEBP, BMP, GIF, SVG, TIF, TIFF, HEIC, AVIF).',
      duration: 5000,
    });
    input.value = '';
    return;
  }

  return validFiles;
}
